export default __webpack_public_path__ + "static/media/pic66.265bce75.jpg";